import * as Yup from 'yup';

export const hba1cGoalValidationSchema = Yup.object({
  current_value: Yup.number()
    .required('Current HbA1C is required')
    .min(3, 'HbA1C must be at least 3%')
    .max(20, 'HbA1C must be at most 20%'),
  target_value: Yup.number()
    .required('Target HbA1C is required')
    .min(3, 'HbA1C must be at least 3%')
    .max(20, 'HbA1C must be at most 20%'),
  target_date: Yup.date()
    .required('Target date is required')
    .min(
      new Date(Date.now() + 24 * 60 * 60 * 1000),
      'Target date must be tomorrow or later'
    )
});
